import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PresignedUrlResponse } from '../../models/PresignedUrl';
import { POST_GSC_REQUEST_DETAIL_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Form Data Model
// =============================================================================
export interface GscDetailFromData {
  specialConsiderationType: string;
  reason: string;
  explanation: string;
}

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostGscDetailRequest extends GscDetailFromData {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRequestDetail = ({ onSuccess, onError }: Input) => {
  const postRequestDetail = async (payload: PostGscDetailRequest) => {
    const res = await axiosClient.post(POST_GSC_REQUEST_DETAIL_URL(payload.uuid), {
      specialConsiderationType: payload.specialConsiderationType,
      reason: payload.reason,
      explanation: payload.explanation,
    });
    return res.data;
  };

  return useCustomMutation(postRequestDetail, {
    onSuccess,
    onError,
  });
};
